// extracted by mini-css-extract-plugin
export var animationContainer = "_mc-0";
export var footer = "_mc-1";
export var gray = "_mc-2";
export var lineItem = "_mc-3";
export var lineItemImage = "_mc-4";
export var lineItemInfo = "_mc-5";
export var lineItemText = "_mc-6";
export var lineItems = "_mc-7";
export var modalContent = "_mc-8";
export var options = "_mc-9";
export var orderName = "_mc-a";
export var refundAmount = "_mc-b";